class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="q"]');
    this.predictiveSearchResults = this.querySelector('[data-ref="predictive-search"]');
    this.abortController = null;

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this),
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.abort();
      this.hide();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  abort() {
    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }
  }

  getSearchResults(searchTerm) {
    // une frappe annule la requete precedente : un resultat lent ne peut plus
    // ecraser un resultat plus recent
    this.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    const url = `${Theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search&resources[type]=product,collection,page,article`;

    fetch(url, { signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Predictive search: ${response.status}`);
        }

        return response.text();
      })
      .then((text) => {
        const section = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
        const resultsMarkup = section ? section.innerHTML.trim() : '';

        if (!resultsMarkup) {
          this.hide();
          return;
        }

        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.show();
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        this.hide();
      });
  }

  show() {
    this.predictiveSearchResults.style.display = 'block';
  }

  hide() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}
